export function formatPhoneBR(value) {
  if (!value) return "";

  const digits = value.replace(/\D/g, "");

  if (digits.length < 12) return value;

  const country = digits.slice(0, 2);
  const ddd = digits.slice(2, 4);
  const number = digits.slice(4);

  if (number.length === 9) {
    return `+${country} (${ddd}) ${number.slice(0, 5)}-${number.slice(5)}`;
  }

  if (number.length === 8) {
    return `+${country} (${ddd}) ${number.slice(0, 4)}-${number.slice(4)}`;
  }

  return value;
}
